/**
 * LE DÉNICHEUR — ajoute le lien "Quiz olfactif" dans le header (desktop + mobile),
 * juste après "Nos Produits".
 *
 * La navigation de `sections/header-denicheur.liquid` peut être pilotée soit
 * par des blocs `nav_item` (config actuelle de la section), soit par une
 * liste codée en dur en fallback — les deux génèrent des attributs
 * (data-dropdown / data-target) différents. Plutôt que de dépendre de l'un ou
 * l'autre, on repère l'item par son libellé visible ("Nos Produits"), stable
 * dans les deux cas. Si on ne le trouve pas (nav reconfigurée autrement), le
 * lien est simplement ajouté en fin de liste — jamais d'échec silencieux total.
 */
(function () {
  "use strict";

  function findItemByLabel(list, label) {
    var items = list.children;
    for (var i = 0; i < items.length; i++) {
      var trigger = items[i].querySelector("a, button");
      if (trigger && trigger.textContent.trim().indexOf(label) === 0) return items[i];
    }
    return null;
  }

  function makeLink(className, linkClass) {
    var li = document.createElement("li");
    li.className = className;
    var a = document.createElement("a");
    a.href = "/pages/quiz";
    a.className = linkClass;
    a.textContent = "Quiz olfactif (bêta)";
    li.appendChild(a);
    return li;
  }

  function insertAfterOrAppend(list, afterEl, li) {
    if (afterEl && afterEl.parentElement === list) {
      afterEl.insertAdjacentElement("afterend", li);
    } else {
      list.appendChild(li);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Desktop
    var desktopList = document.querySelector(".ld-header__nav-list");
    if (desktopList && !desktopList.querySelector('a[href="/pages/quiz"]')) {
      var desktopAfter = findItemByLabel(desktopList, "Nos Produits");
      insertAfterOrAppend(desktopList, desktopAfter, makeLink("ld-header__nav-item", "ld-header__nav-link"));
    }

    // Mobile drawer
    var mobileList = document.querySelector(".ld-mobile-nav__list");
    if (mobileList && !mobileList.querySelector('a[href="/pages/quiz"]')) {
      var mobileAfter = findItemByLabel(mobileList, "Nos Produits");
      insertAfterOrAppend(mobileList, mobileAfter, makeLink("ld-mobile-nav__item", "ld-mobile-nav__link"));
    }
  });
})();
